import { render, staticRenderFns } from "./TaxRulesList.vue?vue&type=template&id=767943fc&"
import script from "./TaxRulesList.vue?vue&type=script&lang=js&"
export * from "./TaxRulesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports